import React from "react";
import { Box, Typography } from "@common-ui/ui";
import logoPng from "./line.svg";
export const Logo = ({ product }) => {
  return (
    <Box>
      <Typography
        variant="h3"
        sx={{
          color: "#ffffff",
          fontFamily: `"Montserrat Bold", "Montserrat Bold", "Montserrat", sans-serif`,
          fontWeight: 700,
          mt: -2,
          fontSize: "32px",
        }}
      >
        {product}
      </Typography>
      <Box
        sx={{
          // width: "131px",
          height: "3px",
          boxSizing: "border-box",
          mt: -2,
        }}
      >
        <img src={logoPng} alt="My Work Logo PNG" />
      </Box>
    </Box>
  );
};
